import { Produkt } from "./produkt";
import { Column } from "./option";
import {
  MatrixColumnFormData,
  OptionPriceInformation,
} from "./optionPriceInformation";

export class OptionRequest {
  //  both
  id: string;
  optionName: string;
  optionType: string;
  sortId: number;
  optionGroupId: string;
  preislistenKatalogId: string;
  optionPriceInformation: OptionPriceInformationBaseRequest;
  associatedProducts: string[];

  //  DE
  optionPosition: string;
  optionUnitId: string;
  fixedValue: number;

  //  US
  invoiceCategory: string;
  glCode: string;
  quantityType: string;
  requiredQuantityType: string;
  costsPer: string;
  ancillaryCode: string;
  dependentOptions: string[];
  hideInFrontend: boolean;
  covers: boolean;

  // TODO: Delete in future after Option importer feature
  cartonColumnNames: string[];
  // gets replaced with
  columns: ColumnRequest[];

  constructor(
    optionName: string,
    optionType: string,
    optionPosition: string,
    sortId: number,
    fixedValue: number,
    optionGroupId: string,
    preislistenKatalogId: string,
    optionUnitId: string,
    optionPriceInformation: OptionPriceInformationBaseRequest,
    associatedProducts: string[],
    invoiceCategory: string,
    glCode: string,
    requiredQuantityType: string,
    quantityType: string,
    costsPer: string,
    cartonColumnNames: string[],
    columns: Column[],
    ancillaryCode: string,
    dependentOptions: string[],
    hideInFrontend: boolean,
    covers: boolean
  ) {
    this.optionName = optionName;
    this.optionType = optionType;
    this.optionPosition = optionPosition;
    this.sortId = sortId;
    this.fixedValue = fixedValue;
    this.optionGroupId = optionGroupId;
    this.preislistenKatalogId = preislistenKatalogId;
    this.optionUnitId = optionUnitId;
    this.optionPriceInformation = optionPriceInformation;
    this.associatedProducts = associatedProducts;
    this.invoiceCategory = invoiceCategory;
    this.glCode = glCode;
    this.requiredQuantityType = requiredQuantityType;
    this.quantityType = quantityType;
    this.costsPer = costsPer;
    this.cartonColumnNames = cartonColumnNames;
    this.columns = columns.map((col) => new ColumnRequest(col.valueTo));
    this.ancillaryCode = ancillaryCode;
    this.dependentOptions = dependentOptions;
    this.hideInFrontend = hideInFrontend;
    this.covers = covers;
  }
}

// Aufteilung der

export class ColumnRequest {
  valueTo: number;

  constructor(valueTo: number) {
    this.valueTo = valueTo;
  }
}

export class OptionPriceInformationBaseRequest {}

export class OptionPriceInformationRequestDe extends OptionPriceInformationBaseRequest {
  von: number;
  bis: number;
  fixKosten: number;
  variableKosten: number;
  fortDruckKosten: number;

  constructor(
    von: number,
    bis: number,
    fixKosten: number,
    variableKosten: number,
    fortDruckKosten: number
  ) {
    super();
    this.von = von;
    this.bis = bis;
    this.fixKosten = fixKosten;
    this.variableKosten = variableKosten;
    this.fortDruckKosten = fortDruckKosten;
  }
}

export class OptionPriceInformationRequestUsCarton extends OptionPriceInformationBaseRequest {
  from: number;
  to: number;
  col0: number;
  col1: number;
  col2: number;
  col3: number;
  col4: number;
  col5: number;
  col6: number;
  col7: number;
  col8: number;
  col9: number;

  constructor(
    from: number,
    to: number,
    col0: number,
    col1?: number,
    col2?: number,
    col3?: number,
    col4?: number,
    col5?: number,
    col6?: number,
    col7?: number,
    col8?: number,
    col9?: number
  ) {
    super();
    this.from = from;
    this.to = to;
    this.col0 = col0;
    if (col1) {
      this.col1 = col1!;
    }
    if (col2) {
      this.col2 = col2!;
    }
    if (col3) {
      this.col3 = col3!;
    }
    if (col4) {
      this.col4 = col4!;
    }
    if (col5) {
      this.col5 = col5!;
    }
    if (col6) {
      this.col6 = col6!;
    }
    if (col7) {
      this.col7 = col7!;
    }
    if (col8) {
      this.col8 = col8!;
    }
    if (col9) {
      this.col9 = col9!;
    }
  }
}

export class OptionPriceInformationRequestUsDifference extends OptionPriceInformationBaseRequest {
  from: number;
  to: number;
  col0: number;

  constructor(from: number, to: number, col0: number) {
    super();
    this.from = from;
    this.to = to;
    this.col0 = col0;
  }
}

export class OptionPriceInformationRequestUsInsert extends OptionPriceInformationBaseRequest {
  from: number;
  to: number;
  insertPages: number;
  insertConfig: string;
  makeReady: number;
  plates: number;
  run: number;

  constructor(
    from: number,
    to: number,
    insertPages: number,
    insertConfig: string,
    makeReady: number,
    plates: number,
    run: number
  ) {
    super();
    this.from = from;
    this.to = to;
    this.insertPages = insertPages;
    this.insertConfig = insertConfig;
    this.makeReady = makeReady;
    this.plates = plates;
    this.run = run;
  }
}

export class OptionPriceInformationRequestUsOTP extends OptionPriceInformationBaseRequest {
  price: number;

  constructor(price: number) {
    super();
    this.price = price;
  }
}

export class OptionPriceInformationRequestUsSurchargeAndSubSurcharge extends OptionPriceInformationBaseRequest {
  surcharge: number;

  constructor(surcharge: number) {
    super();
    this.surcharge = surcharge;
  }
}

export class OptionPriceInformationRequestUsMatrix extends OptionPriceInformationBaseRequest {
  from: number;
  to: number;
  values: number[];

  constructor(
    optionPriceInformation: OptionPriceInformation,
    columns: Column[]
  ) {
    super();
    this.from = optionPriceInformation.from;
    this.to = optionPriceInformation.to;
    this.values = this.transformToValues(optionPriceInformation, columns);
  }

  transformToValues(
    optionPriceInformation: OptionPriceInformation,
    columns: Column[]
  ) {
    let values: number[] = [];
    columns.forEach((col, index) => {
      values[index] = optionPriceInformation[`column${index}`];
    });
    return values;
  }
}
